<template>
  <tr class="reporting-row-component">
    <td>
      {{ category ? category.name : '' }}
    </td>

    <td>
      <div v-bind:style="{ color: priorityColor }">
        <phone-return-icon v-if="task.type === 1"></phone-return-icon>
        <magnify-icon v-else-if="task.type === 2"></magnify-icon>
        <email-icon v-else-if="task.type === 3"></email-icon>
        <cake-variant-icon v-else-if="task.type === 4"></cake-variant-icon>
        <calendar-check-icon v-else></calendar-check-icon>
        {{ task.content }}
      </div>
    </td>

    <td v-if="showDescription">
      {{ task.description }}
    </td>

    <td>
            <span v-for="productLabel in productLabels" v-if="hasProductLabels"
                  :style="{'background-color': '#'+productLabel.color}"
                  class="label label-default">
                {{ productLabel.tag }}
            </span>
    </td>

    <td>
      <BadgeComponent v-if="task.customer" :customer="task.customer.data"></BadgeComponent>
    </td>

    <td>
      <UserBadgeComponent v-if="hasCreator" :user="task.creator.data"></UserBadgeComponent>
    </td>
    <td>
      {{ date }}
    </td>
    <td>
      <TaskBadgeGroupComponent :departments="task.departments.data"
                               :users="task.users.data"></TaskBadgeGroupComponent>
    </td>
    <td>
      {{ status }}
    </td>
  </tr>
</template>

<script>
import BadgeComponent from "~/modules/customer/components/BadgeComponent";
import UserBadgeComponent from "~/modules/user/components/BadgeComponent";
import EmailStatusComponent from "~/modules/email/components/EmailStatusComponent";
import TaskBadgeGroupComponent from "~/modules/task/components/TaskBadgeGroupComponent";
import DateFormatEnum from '~/enums/DateFormatEnum';
import TaskStatus from "~/enums/TaskStatusEnum";

const moment = require("moment");

export default {
  name: "ReportingRowComponent",
  props: {
    task: {
      type: Object,
      required: true
    },
    category: {
      type: Object,
      required: true,
    },
    showDescription: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    BadgeComponent,
    UserBadgeComponent,
    EmailStatusComponent,
    TaskBadgeGroupComponent
  },
  data() {
    return {
      editing: false,
      updateNameLoading: false,
      processLoading: false,
      unmatchLoading: false,
    };
  },
  computed: {
    date() {
      return moment(this.task.date, moment.ISO_8601).format(DateFormatEnum.DISPLAY_DATE);
    },
    hasDescription() {
      return this.task.description !== null && this.task.description.length > 0;
    },
    hasCustomer() {
      return typeof this.task.customer_id !== "undefined" && this.task.customer_id !== null && typeof this.task.customer !== "undefined" && this.task.customer !== null && this.task.customer.data !== null;
    },
    hasCreator() {
      return typeof this.task.user_id !== "undefined" && this.task.user_id !== null && typeof this.task.creator !== "undefined" && this.task.creator !== null;
    },
    hasFinisher() {
      return typeof this.task.finished_by !== "undefined" && this.task.finished_by !== null && this.task.finisher !== null;
    },
    hasAttachments() {
      return typeof this.task.attachables !== "undefined" && this.task.attachables !== null && this.task.attachables.data.length > 0;
    },
    hasProductLabels() {
      return typeof this.task.product_labels !== "undefined" && this.task.product_labels !== null && typeof this.task.product_labels.data !== "undefined" && this.task.product_labels.data !== null;
    },
    productLabels() {
      return this.hasProductLabels ? this.task.product_labels.data : [];
    },
    priorityColor() {
      if (this.task.priority === 0) {
        return '#ff0000';
      } else if (this.task.priority === 1) {
        return '#ee7600';
      } else if (this.task.priority === 2) {
        return '#000000';
      } else if (this.task.priority === 3) {
        return '#757575';
      } else {
        return '#000000';
      }
    },
    status() {
      if (this.task.status === TaskStatus.ACTIVE) {
        return 'Actief';
      } else if (this.task.status === TaskStatus.COMPLETED) {
        return 'Afgerond';
      } else {
        return 'Onbekend';
      }
    },
  },
  methods: {}
};
</script>

<style scoped>
tr td.half-padding {
  padding: 4px;
}

tr.selected {
  background-color: #1890ff1c;
}

table th.compact, table td.compact {
  white-space: nowrap;
  width: 1px !important;
}

tr .pencil-icon {
  display: none;
}

tr:hover .pencil-icon {
  display: initial;
}
</style>
